import { FC, memo } from 'react'
import dynamic from 'next/dynamic'

const TextEditor = dynamic(() => import('./Component'), {
  ssr: false,
})

export type TextEditorBasicProps = {
  initialHtml: any
  setHtml: (html: string) => void
  readOnly?: boolean
  modules?: any
}

const BasicTextEditor: FC<TextEditorBasicProps> = (props) => {
  return <TextEditor {...props} />
}

export default memo(BasicTextEditor)
